import { type IamApi } from '@/features/iam/api/iam-api'
import { type SetMemberFn } from '@/features/iam/members/MemberStore'
import { Id } from '@/infra/id'
import { mapInvitationResourceToInvitation } from './invitation-mappers'

/**
 * Params for {@link InvitationStore.inviteToTeam}.
 */
export interface InviteToTeamParams {
  email: string
  workspaceId: Id
  teamId: Id
  teamRoleId: Id
}

export class InvitationStore {
  constructor(
    private readonly _api: IamApi,
    private readonly _setMember: SetMemberFn,
  ) {}

  /**
   * Fetches an invitation by ID or token.
   */
  async fetchInvitation(idOrToken: string, signal?: AbortSignal) {
    const resource = await this._api.invitations.get(idOrToken, signal)
    return mapInvitationResourceToInvitation(resource)
  }

  /**
   * Invites a user to a team's workspace and the team.
   */
  async inviteToTeam(params: InviteToTeamParams): Promise<void> {
    await this._api.invitations.create({
      email: params.email,
      workspace_id: Id.assert(params.workspaceId),
      team_id: Id.assert(params.teamId),
      team_role_id: Id.assert(params.teamRoleId),
      target: 'Portal',
    })
  }

  /**
   * Accepts an invitation
   */
  async accept(token: string) {
    return this._api.invitations.accept(token, {}).then(this._setMember)
  }
}
